const base = {
  help: 'Ajuda',
  others: 'outros',
  here: 'aqui',
};

export default base;
